import { c as _c } from "react/compiler-runtime";
import { DateRangePicker, FormSelect, toast } from '@systemeio/ui';
import { BookingDetailsModal } from 'modules/calendar/bookings/components/booking-details-modal';
import { BookingStatus } from 'modules/calendar/bookings/components/booking-status';
import { RescheduleBookingModal } from 'modules/calendar/bookings/components/reshedule-booking-modal';
import { BookingStatusEnum } from 'modules/calendar/bookings/constants';
import { getPaymentStatusBooking } from 'modules/calendar/bookings/enums/payment-status-booking-enum';
import { useBookingAction } from 'modules/calendar/bookings/hooks/use-booking-action';
import { useBookings } from 'modules/calendar/bookings/hooks/use-bookings';
import { BookingViewInterface } from 'modules/calendar/bookings/types/bookings-interface';
import TabMenu from 'modules/calendar/components/tab-menu';
import { calendarLoco, getReadableBookingStatus } from 'modules/calendar/constants/calendar-loco';
import { EventTypeEnum, eventTypeLocoKeys } from 'modules/calendar/events/enums/event-type-enum';
import { useMyEvents } from 'modules/calendar/events/hooks/use-my-events';
import { BookingsFilterInterface } from 'modules/calendar/events/types/calendar-filter-interface';
import { NextPage } from 'next';
import Badge from 'shared/components/badge';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { TIME_LABELS, TimeType } from 'shared/components/date-picker/time-delay-picker/constants';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { dateFormat, timeFormat } from 'shared/utils/date-time-format';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useModal } from 'shared/hooks/use-modal';
const defaultFilters: BookingsFilterInterface = {
  dateRange: {
    startDate: null,
    endDate: null
  }
};
const Bookings: NextPage = () => {
  const $ = _c(168);
  const {
    t,
    tICU
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit,
    filter,
    setFilter
  } = useFilterPagination(defaultFilters);
  const bookingModal = useModal();
  let t0;
  if ($[0] !== filter || $[1] !== limit || $[2] !== pagination) {
    t0 = {
      limit,
      pagination,
      filter
    };
    $[0] = filter;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    bookings,
    counter,
    mutate
  } = useBookings(t0);
  const {
    rescheduleBooking,
    cancelBooking,
    deleteBooking
  } = useBookingAction();
  const {
    myEvents
  } = useMyEvents();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[4] !== t) {
    t1 = t("dashboard.calendar.event_name");
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = {
      key: "eventName",
      header: t1,
      widthPercent: 10
    };
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t) {
    t3 = t("global.date");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== user?.dateFormat) {
    t4 = booking => <>{dateFormat(booking.date, {
        dateFormat: user?.dateFormat
      })}</>;
    $[10] = user?.dateFormat;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = {
      key: "date",
      header: t3,
      widthPercent: 10,
      onRender: t4
    };
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t) {
    t6 = t("global.time");
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== user?.timeFormat) {
    t7 = booking_0 => <>{timeFormat(booking_0.date, {
        timeFormat: user?.timeFormat
      })}</>;
    $[17] = user?.timeFormat;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = {
      key: "time",
      header: t6,
      widthPercent: 10,
      onRender: t7
    };
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t) {
    t9 = t("dashboard.calendar.event_duration");
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== tICU) {
    t10 = booking_1 => <>{booking_1.eventDuration}{" "}{tICU(TIME_LABELS[TimeType.MINUTES], {
        count: booking_1.eventDuration
      })}</>;
    $[24] = tICU;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t9) {
    t11 = {
      key: "eventDuration",
      header: t9,
      widthPercent: 10,
      onRender: t10
    };
    $[26] = t10;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("global.status");
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12) {
    t13 = {
      key: "status",
      header: t12,
      widthPercent: 10,
      onRender: _temp
    };
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t) {
    t14 = t("dashboard.calendar.bookings.payment_title");
    $[33] = t;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t) {
    t15 = booking_3 => <Badge text={t(getPaymentStatusBooking(booking_3.paymentStatus))} classNames="bg-background-primary/70 text-text-primary w-fit capitalize" />;
    $[35] = t;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t14 || $[38] !== t15) {
    t16 = {
      key: "payment_status",
      header: t14,
      widthPercent: 10,
      onRender: t15
    };
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t) {
    t17 = t("dashboard.calendar.event_type");
    $[40] = t;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t) {
    t18 = booking_4 => <span>{t(eventTypeLocoKeys[booking_4.eventType])}</span>;
    $[42] = t;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t17 || $[45] !== t18) {
    t19 = {
      key: "event_type",
      header: t17,
      widthPercent: 10,
      onRender: t18
    };
    $[44] = t17;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t) {
    t20 = t("dashboard.calendar.event_invitee");
    $[47] = t;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t20) {
    t21 = {
      key: "invitee",
      header: t20,
      widthPercent: 10,
      onRender: _temp2
    };
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t11 || $[52] !== t13 || $[53] !== t16 || $[54] !== t19 || $[55] !== t2 || $[56] !== t21 || $[57] !== t5 || $[58] !== t8) {
    t22 = [t2, t5, t8, t11, t13, t16, t19, t21];
    $[51] = t11;
    $[52] = t13;
    $[53] = t16;
    $[54] = t19;
    $[55] = t2;
    $[56] = t21;
    $[57] = t5;
    $[58] = t8;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  const columns = t22;
  let t23;
  if ($[60] !== deleteBooking || $[61] !== revalidateModules) {
    t23 = async bookingId => {
      await deleteBooking(bookingId);
      await revalidateModules([RequestModuleEnum.CalendarBookings], true);
    };
    $[60] = deleteBooking;
    $[61] = revalidateModules;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  const onDeleteBooking = t23;
  let t24;
  if ($[63] !== cancelBooking || $[64] !== revalidateModules) {
    t24 = async booking_6 => {
      await cancelBooking(booking_6.id, booking_6.eventType);
      await revalidateModules([RequestModuleEnum.CalendarBookings], true);
    };
    $[63] = cancelBooking;
    $[64] = revalidateModules;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  const onCancelBooking = t24;
  let t25;
  if ($[66] !== mutate || $[67] !== rescheduleBooking || $[68] !== revalidateModules || $[69] !== t) {
    t25 = async (date, booking_7) => {
      ;
      try {
        if (!booking_7) {
          return;
        }
        await rescheduleBooking({
          id: booking_7.id,
          date
        }, booking_7.eventType);
        await mutate(data => {
          if (data) {
            return {
              items: data.items.map(item => {
                if (item.id === booking_7.id) {
                  item = {
                    ...item,
                    date
                  };
                }
                return item;
              }),
              hasMore: data.hasMore
            };
          }
        }, false);
        await revalidateModules([RequestModuleEnum.CalendarBookings]);
        toast.success(t("dashboard.bookings.actions.reschedule_booking_success"));
      } catch (t26) {
        const e = t26;
        throw e;
      }
    };
    $[66] = mutate;
    $[67] = rescheduleBooking;
    $[68] = revalidateModules;
    $[69] = t;
    $[70] = t25;
  } else {
    t25 = $[70];
  }
  const onRescheduleBooking = t25;
  let t26;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <TabMenu />;
    $[71] = t26;
  } else {
    t26 = $[71];
  }
  let t27;
  if ($[72] !== t) {
    t27 = t("dashboard.calendar.title_bookings");
    $[72] = t;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  let t28;
  if ($[74] !== filter || $[75] !== setFilter) {
    t28 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[74] = filter;
    $[75] = setFilter;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  let t29;
  if ($[77] !== pagination || $[78] !== setPagination) {
    t29 = {
      pagination,
      setPagination
    };
    $[77] = pagination;
    $[78] = setPagination;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  let t30;
  if ($[80] !== limit || $[81] !== setLimit) {
    t30 = {
      limit,
      setLimit
    };
    $[80] = limit;
    $[81] = setLimit;
    $[82] = t30;
  } else {
    t30 = $[82];
  }
  let t31;
  if ($[83] !== myEvents || $[84] !== t) {
    t31 = {
      field: "eventId",
      onRender: (value, onChange) => <FormSelect data={myEvents?.map(_temp3)} onChange={onChange} value={value} placeholder={t("dashboard.calendar.bookings.filters.select_eventType")} />
    };
    $[83] = myEvents;
    $[84] = t;
    $[85] = t31;
  } else {
    t31 = $[85];
  }
  let t32;
  if ($[86] !== t) {
    t32 = {
      field: "status",
      onRender: (value_0, onChange_0) => <FormSelect data={Object.values(BookingStatusEnum).map(status => ({
        id: status,
        caption: t(getReadableBookingStatus(status))
      }))} onChange={onChange_0} value={value_0} placeholder={t("global.status")} />
    };
    $[86] = t;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== intlLocale || $[89] !== setFilter || $[90] !== t || $[91] !== user?.createdAt || $[92] !== user?.timezone) {
    t33 = {
      field: "dateRange",
      onRender: (value_1, onChange_1) => <DateRangePicker date={[value_1.startDate, value_1.endDate]} onChange={t34 => {
        const [startDate, endDate] = t34;
        setFilter(prev => ({
          ...prev,
          dateRange: {
            startDate: startDate && startDate.split("T")[0],
            endDate: endDate && endDate.split("T")[0]
          }
        }));
        onChange_1({
          startDate,
          endDate
        });
      }} placeholder={t("dashboard.datepicker.custom_range")} timezone={user?.timezone} createdAt={user?.createdAt} intlLocale={intlLocale} />
    };
    $[88] = intlLocale;
    $[89] = setFilter;
    $[90] = t;
    $[91] = user?.createdAt;
    $[92] = user?.timezone;
    $[93] = t33;
  } else {
    t33 = $[93];
  }
  let t34;
  if ($[94] !== t31 || $[95] !== t32 || $[96] !== t33) {
    t34 = [t31, t32, t33];
    $[94] = t31;
    $[95] = t32;
    $[96] = t33;
    $[97] = t34;
  } else {
    t34 = $[97];
  }
  let t35;
  if ($[98] !== t28 || $[99] !== t29 || $[100] !== t30 || $[101] !== t34) {
    t35 = {
      filterer: t28,
      paginator: t29,
      limiter: t30,
      testAttributePostfix: "filter-btn",
      filterable: t34
    };
    $[98] = t28;
    $[99] = t29;
    $[100] = t30;
    $[101] = t34;
    $[102] = t35;
  } else {
    t35 = $[102];
  }
  let t36;
  if ($[103] !== t) {
    t36 = t("dashboard.calendar.title_booking");
    $[103] = t;
    $[104] = t36;
  } else {
    t36 = $[104];
  }
  let t37;
  if ($[105] !== limit || $[106] !== setLimit) {
    t37 = {
      limit,
      setLimit
    };
    $[105] = limit;
    $[106] = setLimit;
    $[107] = t37;
  } else {
    t37 = $[107];
  }
  let t38;
  if ($[108] !== pagination || $[109] !== setPagination) {
    t38 = {
      pagination,
      setPagination
    };
    $[108] = pagination;
    $[109] = setPagination;
    $[110] = t38;
  } else {
    t38 = $[110];
  }
  let t39;
  if ($[111] !== bookingModal) {
    t39 = booking_8 => bookingModal.open(booking_8);
    $[111] = bookingModal;
    $[112] = t39;
  } else {
    t39 = $[112];
  }
  let t40;
  if ($[113] !== onDeleteBooking) {
    t40 = {
      shouldRender: _temp4,
      onChange: t41 => {
        const {
          id: id_0
        } = t41;
        return onDeleteBooking(id_0);
      }
    };
    $[113] = onDeleteBooking;
    $[114] = t40;
  } else {
    t40 = $[114];
  }
  let t41;
  if ($[115] !== t) {
    t41 = t("dashboard.bookings.actions.reschedule_booking");
    $[115] = t;
    $[116] = t41;
  } else {
    t41 = $[116];
  }
  let t42;
  if ($[117] !== onRescheduleBooking) {
    t42 = (opened, onClose, booking_10, key) => <RescheduleBookingModal opened={opened} onClose={onClose} booking={booking_10} onRescheduleBooking={onRescheduleBooking} key={key} eventType={booking_10.eventType} bookingId={booking_10.id} />;
    $[117] = onRescheduleBooking;
    $[118] = t42;
  } else {
    t42 = $[118];
  }
  let t43;
  if ($[119] !== t41 || $[120] !== t42) {
    t43 = {
      name: "reschedule",
      caption: t41,
      shouldRender: _temp5,
      onActionRender: t42
    };
    $[119] = t41;
    $[120] = t42;
    $[121] = t43;
  } else {
    t43 = $[121];
  }
  let t44;
  if ($[122] !== t) {
    t44 = t("dashboard.bookings.actions.cancel_booking");
    $[122] = t;
    $[123] = t44;
  } else {
    t44 = $[123];
  }
  let t45;
  if ($[124] !== onCancelBooking || $[125] !== t) {
    t45 = (opened_0, onClose_0, booking_12, key_0) => <ConfirmationModal toastCaption={t("dashboard.bookings.actions.cancel_booking_success")} confirmationText={t("dashboard.calendar.bookings.actions.cancel_booking_confirm")} key={key_0} opened={opened_0} onClose={onClose_0} onConfirm={() => onCancelBooking(booking_12)} />;
    $[124] = onCancelBooking;
    $[125] = t;
    $[126] = t45;
  } else {
    t45 = $[126];
  }
  let t46;
  if ($[127] !== t44 || $[128] !== t45) {
    t46 = {
      name: "cancel_booking",
      caption: t44,
      shouldRender: _temp6,
      onActionRender: t45
    };
    $[127] = t44;
    $[128] = t45;
    $[129] = t46;
  } else {
    t46 = $[129];
  }
  let t47;
  if ($[130] !== t) {
    t47 = t("dashboard.calendar.bookings.booking_details.title");
    $[130] = t;
    $[131] = t47;
  } else {
    t47 = $[131];
  }
  let t48;
  if ($[132] !== onCancelBooking || $[133] !== onRescheduleBooking) {
    t48 = (opened_1, onClose_1, booking_13, key_1) => <BookingDetailsModal key={key_1} opened={opened_1} onClose={onClose_1} booking={booking_13} onRescheduleBooking={onRescheduleBooking} onCancelBooking={onCancelBooking} />;
    $[132] = onCancelBooking;
    $[133] = onRescheduleBooking;
    $[134] = t48;
  } else {
    t48 = $[134];
  }
  let t49;
  if ($[135] !== t47 || $[136] !== t48) {
    t49 = {
      name: "booking_details",
      caption: t47,
      onActionRender: t48
    };
    $[135] = t47;
    $[136] = t48;
    $[137] = t49;
  } else {
    t49 = $[137];
  }
  let t50;
  if ($[138] !== t43 || $[139] !== t46 || $[140] !== t49) {
    t50 = [t43, t46, t49];
    $[138] = t43;
    $[139] = t46;
    $[140] = t49;
    $[141] = t50;
  } else {
    t50 = $[141];
  }
  let t51;
  if ($[142] !== t40 || $[143] !== t50) {
    t51 = {
      remove: t40,
      custom: t50
    };
    $[142] = t40;
    $[143] = t50;
    $[144] = t51;
  } else {
    t51 = $[144];
  }
  let t52;
  if ($[145] !== bookings || $[146] !== columns || $[147] !== t36 || $[148] !== t37 || $[149] !== t38 || $[150] !== t39 || $[151] !== t51) {
    t52 = <Table caption={t36} data={bookings} columns={columns} limiter={t37} paginator={t38} onRowClick={t39} actions={t51} />;
    $[145] = bookings;
    $[146] = columns;
    $[147] = t36;
    $[148] = t37;
    $[149] = t38;
    $[150] = t39;
    $[151] = t51;
    $[152] = t52;
  } else {
    t52 = $[152];
  }
  let t53;
  if ($[153] !== bookings || $[154] !== counter || $[155] !== t27 || $[156] !== t35 || $[157] !== t52) {
    t53 = <ListingLayout data={bookings} counter={counter} title={t27} type="compact" filterData={t35}>{t52}</ListingLayout>;
    $[153] = bookings;
    $[154] = counter;
    $[155] = t27;
    $[156] = t35;
    $[157] = t52;
    $[158] = t53;
  } else {
    t53 = $[158];
  }
  let t54;
  if ($[159] !== bookingModal.close || $[160] !== bookingModal.data || $[161] !== bookingModal.opened || $[162] !== onCancelBooking || $[163] !== onRescheduleBooking) {
    t54 = bookingModal.data && <BookingDetailsModal opened={bookingModal.opened} onClose={bookingModal.close} booking={bookingModal.data} onRescheduleBooking={onRescheduleBooking} onCancelBooking={onCancelBooking} />;
    $[159] = bookingModal.close;
    $[160] = bookingModal.data;
    $[161] = bookingModal.opened;
    $[162] = onCancelBooking;
    $[163] = onRescheduleBooking;
    $[164] = t54;
  } else {
    t54 = $[164];
  }
  let t55;
  if ($[165] !== t53 || $[166] !== t54) {
    t55 = <>{t26}{t53}{t54}</>;
    $[165] = t53;
    $[166] = t54;
    $[167] = t55;
  } else {
    t55 = $[167];
  }
  return t55;
};
export const getServerSideProps = getBaseServerSideProps(calendarLoco, 'header.top_menu.bookings');
export default Bookings;
function _temp(booking_2) {
  return <BookingStatus status={booking_2.status} />;
}
function _temp2(booking_5) {
  return booking_5.eventType === EventTypeEnum.Individual ? <LinkWithoutPrefetch className="primary-link" href={`/contacts/${booking_5.contactId}`}>{booking_5.contactName}</LinkWithoutPrefetch> : <span>{`${booking_5.bookedSlots}/${booking_5.maxParticipants}`}</span>;
}
function _temp3(t0) {
  const {
    id,
    name
  } = t0;
  return {
    id,
    caption: name
  };
}
function _temp4(t0) {
  const {
    status: status_0
  } = t0;
  return [BookingStatusEnum.Past, BookingStatusEnum.Cancelled].includes(status_0);
}
function _temp5(booking_9) {
  return booking_9.eventId !== null && booking_9.status !== BookingStatusEnum.Cancelled;
}
function _temp6(booking_11) {
  return booking_11.eventId !== null && ![BookingStatusEnum.Cancelled, BookingStatusEnum.Past].includes(booking_11.status);
}